import { render, staticRenderFns } from "./MotorClaimList.vue?vue&type=template&id=283bfe0c&"
import script from "./MotorClaimList.vue?vue&type=script&lang=js&"
export * from "./MotorClaimList.vue?vue&type=script&lang=js&"
import style0 from "./MotorClaimList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MotorClaimList.vue"
export default component.exports